import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

import { BoxStyled } from './DashboardTransactionsSummary.styled';

export const DashboardTransactionsSummarySkeleton: React.FC = () => (
  <Box sx={{ padding: '16px', borderRadius: '8px', backgroundColor: '#fff' }}>
    <Stack direction="column">
      <Skeleton height={24} variant="text" width="80%" />
      <Skeleton height={20} variant="text" width="60%" />
    </Stack>
    <Stack direction="row" gap="16px" paddingTop="16px">
      {Array.from({ length: 2 }).map((_, index) => (
        <Skeleton height={64} key={index} variant="rounded" width="100%" />
      ))}
    </Stack>
    <Skeleton height={212} sx={{ marginY: '16px' }} variant="rounded" width="100%" />
    <BoxStyled>
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton height={64} key={index} variant="rounded" width="100%" />
      ))}
    </BoxStyled>
  </Box>
);
